class Username {
  static usernameZeeveStyle():string {
    return `.container-username {
        width: 46px;
        height: 44px;
        border-radius: 40px;
        /* margin-top: 5px; */
        background: rgb(241, 112, 112);
      }
    .username {
        width: 100%;
        text-align: center;
        color: white;
        font-size: 24px;
        line-height: 44px;
      }`;
  }

  static usernameHeliosStyle():string {
    return `.container-username {
        width: 46px;
        height: 44px;
        border-radius: 40px;
        /* margin-top: 5px; */
        background: rgb(241, 112, 112);
      }
    .username {
        width: 100%;
        text-align: center;
        color: white;
        font-size: 24px;
        line-height: 44px;
      }`;
  }
}
export default Username;